import { PageUrlSegment } from '../types';

export const getMainUrlSegment = (url: string): PageUrlSegment => {
  const numberOfSlashes: number = (url.match(/\//g) || []).length;
  let mainUrlSegment = '';
  if (url !== '/') {
    if (url.includes('transfer/checkout') && url.includes('membership')) {
      return PageUrlSegment.TRANSFER_ADD_MEMBERSHIP;
    }
    if (url.includes('transfer/checkout')) {
      return PageUrlSegment.TRANSFER_LANDING;
    }
    if (numberOfSlashes === 3) {
      mainUrlSegment = url.substring(0, url.lastIndexOf('/'));
    } else if (url.includes('?state')) {
      // This condition is to handle the scenarios where we have state
      // uri param is appended to the url after redirected from GH
      mainUrlSegment = '';
    } else if (url.includes('?')) {
      // This condition is to handle giftcard review page
      // where the url pattern is gift_card/review?giftCardId=abcd
      mainUrlSegment = url.substring(0, url.lastIndexOf('?'));
    } else {
      mainUrlSegment = url;
    }
  }
  return mainUrlSegment as PageUrlSegment;
};

export const getUrlParamId = (url: string, delimeter = '/'): string => {
  const parts: string[] = url.split(delimeter);
  return parts[parts.length - 1];
};
